  "use strict";

  //Detect Mobile
  var isMobile = {
      Android: function() {
          return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: function() {
          return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: function() {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: function() {
          return navigator.userAgent.match(/Opera Mini/i);
      },
      Safari: function() {
          return navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
      },
      Windows: function() {
          return navigator.userAgent.match(/IEMobile/i);
      },
      any: function() {
          return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Safari() || isMobile.Windows());
      }
  };


  $(document).ready(function() {
      $('.projects-btn a').click(function() {
          $('.radi-scroll-content').scrollTo(this.hash, 500, {
              easing: 'swing',
              interrupt: true
          });
          return false;
      });
      $('.projects-btn >a').click(function(event) {
          $('.sector-title h2').html($(this).attr('data-atr')).show();
          $('.sector-title > h2').each(function() {
              var originalText = this.innerHTML;
              var newText = originalText.replace(
                  /\bradi\b/gi,
                  '<span class="left">$&</span>'
              );
              if (originalText !== newText) {
                  this.innerHTML = newText;
              }
          });
          $('.sector-title > h2').each(function() {
              var originalText = this.innerHTML;
              var newText = originalText.replace(
                  /\bgmbh\b/gi,
                  '<span class="left">$&</span>'
              );
              if (originalText !== newText) {
                  this.innerHTML = newText;
              }
          });
      });
  });
  $(document).ready(function() {
      if (!isMobile.any()) {
          $(document).ready(function() {
              $('.project-wrap').hover(function(e) {
                  $('.sector-title h2').html($(this).attr('data-atr')).show();

                  $('.sector-title > h2').each(function() {
                      var originalText = this.innerHTML;
                      var newText = originalText.replace(
                          /\bradi\b/gi,
                          '<span class="left">$&</span>'
                      );
                      if (originalText !== newText) {
                          this.innerHTML = newText;
                      }
                  });
                  $('.sector-title > h2').each(function() {
                      var originalText = this.innerHTML;
                      var newText = originalText.replace(
                          /\bgmbh\b/gi,
                          '<span class="left">$&</span>'
                      );
                      if (originalText !== newText) {
                          this.innerHTML = newText;
                      }
                  });

              }, function() {
                  $('.sector-title h2').hide();
              });
          });


      } else {
          $('.project-wrap').scroll(function(event) {
            $('.projects-btn').hide();
              $('.sector-title h2').html($(this).attr('data-atr')).show();
              $('.sector-title > h2').each(function() {
                  var originalText = this.innerHTML;
                  var newText = originalText.replace(
                      /\bradi\b/gi,
                      '<span class="left">$&</span>'
                  );
                  if (originalText !== newText) {
                      this.innerHTML = newText;
                  }
              });
              $('.sector-title > h2').each(function() {
                  var originalText = this.innerHTML;
                  var newText = originalText.replace(
                      /\bgmbh\b/gi,
                      '<span class="left">$&</span>'
                  );
                  if (originalText !== newText) {
                      this.innerHTML = newText;
                  }
              });
          });
          $('.project-wrap').click(function(event) {
            $('.projects-btn').hide();
              $('.sector-title h2').html($(this).attr('data-atr')).show();
              $('.sector-title > h2').each(function() {
                  var originalText = this.innerHTML;
                  var newText = originalText.replace(
                      /\bradi\b/gi,
                      '<span class="left">$&</span>'
                  );
                  if (originalText !== newText) {
                      this.innerHTML = newText;
                  }
              });
              $('.sector-title > h2').each(function() {
                  var originalText = this.innerHTML;
                  var newText = originalText.replace(
                      /\bgmbh\b/gi,
                      '<span class="left">$&</span>'
                  );
                  if (originalText !== newText) {
                      this.innerHTML = newText;
                  }
              });
          });
      }
      // Initialize scroller.
      $('.fullscreen').TrackpadScrollEmulator();
      $('.projects-list li').append('<div class="hide-scroll"></div>')

      $('.sector-title, .fullscreen, .project-wrap').hover(function() {
          $('.drag-handle').addClass('visible');
      }, function() {
          $('.drag-handle').removeClass('visible');
      });



      $('.btn-list-projekte').click(function(event) {
          event.stopPropagation();
          $('.projects-btn').toggle();
      });
      $(document).click(function() {
          $('.projects-btn').hide();
      });

    $('.projects-list,.sector-title h2').on('mouseover', function() {
        $('.projects-btn').hide();
    });

      $('.show-desc').click(function() {
          var $this = $(this);
          $(this).next('.display-none-sm').fadeToggle();
          $this.toggleClass('show-desc');
          if ($this.hasClass('show-desc')) {
              $this.html('<img src="img/more64.png" alt="more">');
          } else {
              $this.text('-');
          }
      });

      $('img, .padding-wrap').mousedown(function(e) {
          if (e.button == 2) {
              return false;
          }
      });

      $('img, .padding-wrap').bind('contextmenu', function(e) {
          return false;
      });

  });

  if (isMobile.Safari()) {
      $('.project-wrap').addClass('ios')
  }


$(document).ready(function () {
    $('.gotop').click(function () {
        $(this).closest(".project-wrap").animate({
            scrollTop: 0
        }, 500);
        // return false;
    });

});


  (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
  (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
  m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
  })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

  ga('create', 'UA-84203257-5', 'auto');
  ga('send', 'pageview');
